module.exports = __webpack_public_path__ + "img/approve.e5abab46.svg";